// extracted by mini-css-extract-plugin
module.exports = {"header":"allocareheader_header__1mtHD","logo":"allocareheader_logo__1y2VA","logoutBtn":"allocareheader_logoutBtn__1q26d"};